'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _lodash = require('lodash');

var _lodash2 = _interopRequireDefault(_lodash);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var DetailController = function DetailController($stateParams, LanguageFactory, ModelFactory, Resource) {
    'ngInject';

    (0, _classCallCheck3.default)(this, DetailController);
    var vm = this;
    vm.language = 'IT';
    vm.setLanguage = setLanguage;
    vm.item = {};
    vm.section = 'description';
    vm.model = '';
    vm.isNew = true;
    vm.$onInit = init;
    vm.init = init;
    vm.getDetail = getDetail;
    vm.createNew = createNew;

    function init() {
        if (!_lodash2.default.has($stateParams, 'id') || !_lodash2.default.has($stateParams, 'modelType')) {
            throw 'incomplete parameters for detail.controller.js';
        }

        vm.modelName = $stateParams.modelName;
        vm.modelEnum = vm.modelName.toUpperCase();

        if ($stateParams.id === "new") {
            vm.isNew = true;
            createNew(vm.modelName);
        } else {
            vm.isNew = false;
            vm.getDetail($stateParams.id, vm.modelName);
        }
    }

    function createNew(modelName) {
        var modelStructure = _lodash2.default.result(ModelFactory, 'get' + _lodash2.default.upperFirst(vm.modelName) + 'Structure');
        vm.item = {};
        vm.item[modelName] = {};
        vm.item[modelName + 'StringsList'] = [];
        var lang = {};

        // Ricostruisci l'oggetto secondo il modello sul backend, incluse
        // le strings list.
        _lodash2.default.each(modelStructure.model, function (value, key) {
            // proprietà di strings list
            if (value.prefix === 'lang') {
                lang[key] = "";
            }
            // proprietà diretta della risorsa
            else if (value.prefix.indexOf("vm.") > -1) {
                    vm.item[modelName][key] = "";
                }
        });

        // Aggiungi tutte le lingue nella strings list
        _lodash2.default.each(LanguageFactory.getAvailableLanguageKeys(), function (l) {
            var langClone = _lodash2.default.clone(lang);
            langClone.language = l;
            vm.item[modelName + 'StringsList'].push(langClone);
        });
    }

    function getDetail(id, modelName) {
        Resource.get(modelName, id).then(function (res) {
            var langs = [];
            var defaultLanguage = _lodash2.default.find(_lodash2.default.get(res.data, modelName + 'StringsList'), { language: LanguageFactory.getDefaultLanguage() });

            console.log("Default language:", defaultLanguage);

            // Aggiungi le lingue mancanti clonando l'italiano,
            // assumendo l'italiano come sempre presente per costruzione.
            _lodash2.default.each(LanguageFactory.getAvailableLanguageKeys(), function (lang) {
                var elem = _lodash2.default.find(_lodash2.default.get(res.data, modelName + 'StringsList'), { language: lang });
                var newElem = {};
                if (!elem && lang !== LanguageFactory.getDefaultLanguage()) {
                    newElem = _lodash2.default.clone(defaultLanguage);
                    newElem.language = lang; //override della lingua di default
                    delete newElem.id; //non salvare l'id!
                    langs.push(newElem);
                } else {
                    langs.push(elem);
                }
            });
            res.data[modelName + 'StringsList'] = langs; //result: res.data.floraStringsList = langs
            console.log('Resource details:', res.data);
            vm.item = res.data;
        });
    }

    function setLanguage(language) {
        vm.language = language;
        // $stateParams.language = vm.language;
    }
};

exports.default = DetailController;


// WEBPACK FOOTER //
// ./client/app/components/dashboard/detail/detail.controller.js